var $body = $("body");
var $styleToggleButton = $(".style-toggle");
var variant_two = "variant-2";
//Set layout on page load
if (typeof Storage !== "undefined") {
    if (localStorage.alternative_layout) {
        if (localStorage.alternative_layout === "true") {
            $body.addClass(variant_two);
        }
        else {
            $body.removeClass(variant_two);
        }
    }
}
var toggleStyle = function () {
    $body.toggleClass(variant_two);
    if (typeof Storage !== "undefined") {
        localStorage.setItem("alternative_layout", $body.hasClass(variant_two).toString());
    }
};
$(document).keydown(function (e) {
    if (e.ctrlKey && e.key == "e") {
        toggleStyle();
        e.preventDefault();
    }
});
$styleToggleButton.click(function () { return toggleStyle(); });
var ImageTouch = /** @class */ (function () {
    function ImageTouch(touch, $parentImage) {
        this.identifier = touch.identifier;
        this.$parentImage = $parentImage;
        //Sets currentX-Y
        this.updateCurrentPosition(touch);
        //Sets originalX-Y
        this.resetOriginalPosition();
        //Sets ratioX-Y
        this.recalculateRatio();
    }
    ImageTouch.prototype.updateCurrentPosition = function (touch) {
        this.currentX = touch.clientX;
        this.currentY = touch.clientY;
    };
    ImageTouch.prototype.resetOriginalPosition = function () {
        this.originalX = this.currentX;
        this.originalY = this.currentY;
    };
    ImageTouch.prototype.recalculateRatio = function () {
        var imageOffset = imageCurrentOffset(this.$parentImage);
        var centerOfPointToLeftWithImageStartAsZero = this.originalX - imageOffset.left;
        var leftRatio = centerOfPointToLeftWithImageStartAsZero / imageCurrentResolution(this.$parentImage).width;
        var centerOfPointToTopWithImageStartAsZero = this.originalY - imageOffset.top;
        var topRatio = centerOfPointToTopWithImageStartAsZero / imageCurrentResolution(this.$parentImage).height;
        this.ratioX = leftRatio;
        this.ratioY = topRatio;
    };
    return ImageTouch;
}());
var ongoingTouches = [];
var ongoingTouchById = function (id) { return ongoingTouches.findIndex(function (element) { return element.identifier == id; }); };
var distanceBetweenTwoPoints = function (aX, aY, bX, bY) {
    //√( (aX - bX)² + (aY - bY)² )
    return Math.sqrt((Math.pow((aX - bX), 2) + Math.pow((aY - bY), 2)));
};
var centerOfTwoPoints = function (aX, aY, bX, bY) { return ({
    x: (aX + bX) / 2,
    y: (aY + bY) / 2
}); };
var getImageWidthWhenTouchHappened = function (firstTouch, secondTouch) {
    var ratioDifference = Math.abs(firstTouch.ratioX - secondTouch.ratioX);
    var positionDifference = Math.abs(firstTouch.originalX - secondTouch.originalX);
    return positionDifference / ratioDifference;
};
var zoomedImageEditedMatrix;
var getNewMatrix = function (x, y, scale) { return "matrix(" + scale + ",0,0," + scale + "," + x + "," + y + ")"; };
var setImageMatrix = function ($image, matrix) {
    $image.css({
        transform: getNewMatrix(matrix.x, matrix.y, matrix.scale)
    });
    zoomedImageEditedMatrix = matrix;
    if (matrix.scale != 1) {
        $imageGallery().addClass("full");
    }
    else {
        $imageGallery().removeClass("full");
    }
};
var animateToMatrix = function ($image, matrix) {
    var initialScale = zoomedImageEditedMatrix.scale;
    var initialX = zoomedImageEditedMatrix.x;
    var initialY = zoomedImageEditedMatrix.y;
    var targetX = matrix.x;
    var targetY = matrix.y;
    var targetScale = matrix.scale;
    //It's tricky to work with nonexistent properties
    //It gets always set to zero, independently the value it's assigned
    //But it remains 1 if nothing is assigned
    $image.css({ customTransformAlpha: 0 });
    $image.animate({ customTransformAlpha: 1 }, {
        duration: animationDuration,
        //Step is used instead of progress, because this way we have the easing
        step: function (value) {
            var scale = interpolate(initialScale, targetScale, value);
            var x = interpolate(initialX, targetX, value);
            var y = interpolate(initialY, targetY, value);
            setImageMatrix($image, { x: x, y: y, scale: scale });
        }
        //No complete or fail, because setImageMatrix already handles the variable for us
    });
};
var interpolate = function (from, to, alpha) { return from + (to - from) * alpha; };
var animationDuration = 400;
var cachedImageResolution = [];
var cachedWindowEventListener = [];
var imageCurrentResolution = function ($image) {
    var originalShownResolution = imageOriginalResolution($image);
    return {
        width: originalShownResolution.width * zoomedImageEditedMatrix.scale,
        height: originalShownResolution.height * zoomedImageEditedMatrix.scale
    };
};
var imageOriginalResolution = function ($image) {
    if (cachedImageResolution.hasOwnProperty($image)) {
        if (cachedImageResolution[$image].hasOwnProperty("originalWidth")
            && cachedImageResolution[$image].hasOwnProperty("originalHeight")) {
            return {
                width: cachedImageResolution[$image].originalWidth,
                height: cachedImageResolution[$image].originalHeight
            };
        }
    }
    else {
        cachedImageResolution[$image] = {};
    }
    var image = $image.get(0);
    var imageRatio = image.naturalWidth / image.naturalHeight;
    var width = $image.height() * imageRatio;
    if (width < $image.width()) {
        cachedImageResolution[$image].originalWidth = width;
        cachedImageResolution[$image].originalHeight = $image.height();
        return {
            width: width,
            height: $image.height()
        };
    }
    var height = $image.width() / imageRatio;
    cachedImageResolution[$image].originalWidth = $image.width();
    cachedImageResolution[$image].originalHeight = height;
    return {
        width: $image.width(),
        height: height
    };
};
var differenceFromOriginalResolutionToCurrentResolution = function ($image) {
    var originalResolution = imageOriginalResolution($image);
    return {
        width: (originalResolution.width * zoomedImageEditedMatrix.scale - originalResolution.width) / 2,
        height: (originalResolution.height * zoomedImageEditedMatrix.scale - originalResolution.height) / 2
    };
};
var imageOriginalOffset = function ($image) {
    if (cachedImageResolution.hasOwnProperty($image)) {
        if (cachedImageResolution[$image].hasOwnProperty("originalTop")
            && cachedImageResolution[$image].hasOwnProperty("originalLeft")) {
            return {
                top: cachedImageResolution[$image].originalTop,
                left: cachedImageResolution[$image].originalLeft
            };
        }
    }
    else {
        cachedImageResolution[$image] = {};
    }
    var originalShownResolution = imageOriginalResolution($image);
    var paddingLeft = Math.abs(originalShownResolution.width - $image.width()) / 2;
    var paddingTop = Math.abs(originalShownResolution.height - $image.height()) / 2;
    cachedImageResolution[$image].originalTop = paddingTop;
    cachedImageResolution[$image].originalLeft = paddingLeft;
    return {
        left: paddingLeft,
        top: paddingTop
    };
};
var imageCurrentOffset = function ($image) {
    var originalPadding = imageOriginalOffset($image);
    var resolutionDifference = differenceFromOriginalResolutionToCurrentResolution($image);
    return {
        top: originalPadding.top - resolutionDifference.height + zoomedImageEditedMatrix.y,
        left: originalPadding.left - resolutionDifference.width + zoomedImageEditedMatrix.x
    };
};
var imageNeededMatrixForPositionAndRatio = function ($image, currentX, currentY, ratioX, ratioY) {
    var currentResolution = imageCurrentResolution($image);
    var originalOffset = imageOriginalOffset($image);
    var resolutionDifference = differenceFromOriginalResolutionToCurrentResolution($image);
    return {
        x: -originalOffset.left + resolutionDifference.width + currentX - currentResolution.width * ratioX,
        y: -originalOffset.top + resolutionDifference.height + currentY - currentResolution.height * ratioY
    };
};
var bindTouchToElement = function ($image, $parent) {
    if ($parent === void 0) { $parent = $image; }
    $parent.on('touchstart', function (jqueryEvent) {
        var ev = jqueryEvent.originalEvent;
        handleStart(ev, $image, $parent);
    });
    $parent.on('touchmove', function (jqueryEvent) {
        var ev = jqueryEvent.originalEvent;
        handleMove(ev, $image, $parent);
    });
    $parent.on('touchend', function (jqueryEvent) {
        var ev = jqueryEvent.originalEvent;
        handleEnd(ev, $image, $parent);
    });
    $parent.on('touchcancel', function (jqueryEvent) {
        var ev = jqueryEvent.originalEvent;
        handleCancel(ev, $image, $parent);
    });
    cachedWindowEventListener[$parent] = window.addEventListener("resize", function () {
        cachedImageResolution[$image] = {};
    });
    setImageMatrix($image, { x: 0, y: 0, scale: 1 });
    ongoingTouches = [];
};
var unbindTouchToElement = function ($parent) {
    $parent.off("touchstart touchmove touchend touchcancel");
    window.removeEventListener("resize", cachedWindowEventListener[$parent]);
};
var handleStart = function (event, $image, $parent) {
    event.preventDefault();
    var touches = event.changedTouches;
    $image.stop();
    $image.removeClass("animate");
    for (var _i = 0, touches_1 = touches; _i < touches_1.length; _i++) {
        var touch = touches_1[_i];
        ongoingTouches.push(new ImageTouch(touch, $image));
    }
};
var handleMove = function (event, $image, $parent) {
    event.preventDefault();
    var touches = event.changedTouches;
    for (var _i = 0, touches_2 = touches; _i < touches_2.length; _i++) {
        var touch = touches_2[_i];
        var id = ongoingTouchById(touch.identifier);
        if (id >= 0) {
            ongoingTouches[id].updateCurrentPosition(touch);
        }
    }
    if (ongoingTouches.length == 1) {
        var currentX = ongoingTouches[0].currentX;
        var currentY = ongoingTouches[0].currentY;
        var ratioX = ongoingTouches[0].ratioX;
        var ratioY = ongoingTouches[0].ratioY;
        var matrixInfo = imageNeededMatrixForPositionAndRatio($image, currentX, currentY, ratioX, ratioY);
        setImageMatrix($image, { x: matrixInfo.x, y: matrixInfo.y, scale: zoomedImageEditedMatrix.scale });
    }
    if (ongoingTouches.length >= 2) {
        var original_aX = ongoingTouches[0].originalX;
        var original_aY = ongoingTouches[0].originalY;
        var original_bX = ongoingTouches[1].originalX;
        var original_bY = ongoingTouches[1].originalY;
        var current_aX = ongoingTouches[0].currentX;
        var current_aY = ongoingTouches[0].currentY;
        var current_bX = ongoingTouches[1].currentX;
        var current_bY = ongoingTouches[1].currentY;
        var distanceOriginal = distanceBetweenTwoPoints(original_aX, original_aY, original_bX, original_bY);
        var distanceCurrent = distanceBetweenTwoPoints(current_aX, current_aY, current_bX, current_bY);
        var scaleRatio = distanceCurrent / distanceOriginal;
        var meanRatio = {
            x: (ongoingTouches[0].ratioX + ongoingTouches[1].ratioX) / 2,
            y: (ongoingTouches[0].ratioY + ongoingTouches[1].ratioY) / 2
        };
        var currentCenter = centerOfTwoPoints(current_aX, current_aY, current_bX, current_bY);
        var originalImageScale = getImageWidthWhenTouchHappened(ongoingTouches[0], ongoingTouches[1]) / imageOriginalResolution($image).width;
        var matrixInfoScale = originalImageScale * scaleRatio;
        var matrixInfo = imageNeededMatrixForPositionAndRatio($image, currentCenter.x, currentCenter.y, meanRatio.x, meanRatio.y);
        setImageMatrix($image, { x: matrixInfo.x, y: matrixInfo.y, scale: matrixInfoScale });
    }
};
var handleEnd = function (event, $image, $parent) {
    event.preventDefault();
    var touches = event.changedTouches;
    for (var _i = 0, touches_3 = touches; _i < touches_3.length; _i++) {
        var touch = touches_3[_i];
        var id = ongoingTouchById(touch.identifier);
        if (id >= 0) {
            ongoingTouches.splice(id, 1); //Delete touch from array
        }
    }
    for (var _a = 0, ongoingTouches_1 = ongoingTouches; _a < ongoingTouches_1.length; _a++) {
        var touch = ongoingTouches_1[_a];
        touch.resetOriginalPosition();
        touch.recalculateRatio();
    }
    if (ongoingTouches.length == 0) {
        if (zoomedImageEditedMatrix.scale < 1) {
            animateToMatrix($image, { x: 0, y: 0, scale: 1 });
        }
        else {
            var imageResolution = imageCurrentResolution($image);
            var imageOffset = imageCurrentOffset($image);
            var originalOffset = imageOriginalOffset($image);
            var resolutionDifferenceFromOriginal = differenceFromOriginalResolutionToCurrentResolution($image);
            var transformToApply = {
                x: zoomedImageEditedMatrix.x,
                y: zoomedImageEditedMatrix.y,
                scale: zoomedImageEditedMatrix.scale
            };
            if (imageResolution.width > $parent.width()) {
                if (imageOffset.left > 0) {
                    transformToApply.x = -originalOffset.left + resolutionDifferenceFromOriginal.width;
                }
                else if (imageOffset.left + imageResolution.width < $parent.width()) {
                    transformToApply.x = -(imageResolution.width - $parent.width()) / 2;
                }
            }
            else {
                transformToApply.x = 0;
            }
            if (imageResolution.height > $parent.height()) {
                if (imageOffset.top > 0) {
                    transformToApply.y = -originalOffset.top + resolutionDifferenceFromOriginal.height;
                }
                else if (imageOffset.top + imageResolution.height < $parent.height()) {
                    transformToApply.y = -(imageResolution.height - $parent.height()) / 2;
                }
            }
            else {
                transformToApply.y = 0;
            }
            animateToMatrix($image, transformToApply);
        }
    }
};
var handleCancel = function (event, $image, $parent) {
    event.preventDefault();
    var touches = event.changedTouches;
    for (var _i = 0, touches_4 = touches; _i < touches_4.length; _i++) {
        var touch = touches_4[_i];
        var id = ongoingTouchById(touch.identifier);
        ongoingTouches.splice(id, 1); //Delete touch from array
    }
};
var $imageGrid = $('.image-grid');
var $body = $('body');
var $imageGallery = function () { return $('.gallery-viewer'); };
var $galleryHolder = function () { return $('.gallery-holder'); };
var $imageGalleryButtonNext = function () { return $imageGallery().find('.button-next'); };
var $imageGalleryButtonPrev = function () { return $imageGallery().find('.button-prev'); };
var $imageGalleryButtonClose = function () { return $imageGallery().find('.button-close'); };
var $nthImage = function (index) { return $galleryHolder().children().eq(index); };
var $nthImageImage = function (index) { return $nthImage(index).children('img'); };
var $nthImageCaption = function (index) { return $nthImage(index).children('figcaption'); };
var galleryImages = [];
var preloadingImages = [];
var initializeGallery = function (figure) {
    if (!$body.hasClass('gallery')) {
        var $galleryViewer = $('<div/>', { "class": 'gallery-viewer' });
        //Add images to array
        galleryImages = [];
        for (var _i = 0, _a = $imageGrid.children("figure").toArray(); _i < _a.length; _i++) {
            var fig = _a[_i];
            galleryImages.push({
                image: $(fig).children('img').data('orig').toString(),
                low_res: $(fig).children('img').attr('src').toString(),
                description: $(fig).children('figcaption').html().toString()
            });
        }
        var index = $imageGrid.children('figure').index(figure);
        var $holder = $('<div/>', { "class": "gallery-holder" });
        var $nextButton = $('<div/>', { "class": "button-next" });
        var $prevButton = $('<div/>', { "class": "button-prev" });
        var $closeButton = $('<div/>', { "class": "button-close" });
        for (var _b = 0, galleryImages_1 = galleryImages; _b < galleryImages_1.length; _b++) {
            var object = galleryImages_1[_b];
            $('<figure/>')
                .append($('<img/>', { src: object.low_res }))
                .append($('<figcaption/>', { text: object.description }))
                .appendTo($holder);
        }
        $galleryViewer
            .append($nextButton)
            .append($prevButton)
            .append($closeButton)
            .append($holder);
        $galleryViewer.appendTo($('main'));
        $galleryViewer.on('click', function (event) {
            if (event.target == event.currentTarget)
                closeGallery();
        });
        $imageGalleryButtonClose().on('click', function () { return closeGallery(); });
        showPicture(index);
        $body.addClass('unscrollable');
    }
};
var closeGallery = function () {
    $imageGallery().remove();
    $body.removeClass('unscrollable');
};
var showPicture = function (index) {
    for (var imageIndex in preloadingImages) {
        if (preloadingImages.hasOwnProperty(imageIndex)) {
            if (imageIndex != index) {
                preloadingImages[imageIndex].xhr.abort();
            }
        }
    }
    //If low res is being shown
    if (preloadingImages.hasOwnProperty(index)
        && preloadingImages[index].hasOwnProperty("blob")
        && preloadingImages[index].blob != null) {
        $nthImageImage(index).attr("src", preloadingImages[index].blob);
    }
    else {
        if (!preloadingImages.hasOwnProperty(index))
            preloadingImages[index] = { xhr: null, blob: null };
        preloadingImages[index].xhr = $.ajax({
            url: galleryImages[index].image,
            cache: true,
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data) {
                preloadingImages[index].blob = URL.createObjectURL(data);
                $nthImageImage(index).attr("src", preloadingImages[index].blob);
            }
        });
    }
    bindTouchToElement($nthImageImage(index), $nthImage(index));
    $nthImageCaption(index).html(galleryImages[index].description);
    var nextIndex = index == galleryImages.length - 1 ? 0 : index + 1;
    var prevIndex = index == 0 ? galleryImages.length - 1 : index - 1;
    for (var i = 0; i < galleryImages.length; i++) {
        $nthImage(i).removeClass("prev next current");
        if (i != index) {
            unbindTouchToElement($nthImage(i));
            $nthImageImage(i).css('width', '');
            $nthImageImage(i).css('left', '');
        }
        //Direct previous || if index ==0, then if last
        if (i == index - 1 || index == 0 && i == galleryImages.length - 1) {
            $nthImage(i).addClass("prev");
        }
        //Direct next || if index is last, then if first
        else if (i == index + 1 || index == galleryImages.length - 1 && i == 0) {
            $nthImage(i).addClass("next");
        }
        else if (i == index) {
            $nthImage(i).addClass("current");
        }
    }
    $imageGalleryButtonNext().off().one('click', function () { return showPicture(index + 1 > galleryImages.length - 1 ? 0 : index + 1); });
    $imageGalleryButtonPrev().off().one('click', function () { return showPicture(index - 1 < 0 ? galleryImages.length - 1 : index - 1); });
};
$imageGrid.children('figure').on('click', function (event) {
    initializeGallery(event.currentTarget);
});
var navButton = $('#menu-button');
var navbar = $('#navbar');
navButton.click(function () {
    var isActive = navbar.hasClass("active");
    if (isActive) {
        navbar.height(navbar.innerHeight());
        navbar.animate({
            height: 0
        }, 250, function () {
            navbar.removeClass("active");
        });
    }
    else {
        navbar.animate({
            height: navbar[0].scrollHeight
        }, 250, function () {
            navbar.addClass("active");
            navbar.height("auto");
        });
    }
});

//# sourceMappingURL=script.js.map
